module.exports = __webpack_public_path__ + "img/header_home.daae4f75.png";